









import { Component, Vue } from 'vue-property-decorator';
import NimiqButton from '@/components/NimiqButton.vue';
import NewsLetterInput from '@/components/NewsLetterInput.vue';

@Component({
  components: { NimiqButton, NewsLetterInput },
})
export default class JoinMailer extends Vue {
  state = 1;
  fastspotAudience = 'ec5716d31c'
}
